<div class="modal-body excel-import-body">

  <!-- File picker -->
  <div class="import-file-section">
    <div class="import-file-input-wrapper">
      <!-- Hidden native input; the styled label below acts as the click target -->
      <input type="file" name="excelFile" class="import-file-input-hidden" id="inputGroupFile" required
        (change)="handleExcelArticlesImport($event)"
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
      <label class="import-file-btn" for="inputGroupFile">
        <i class="bi bi-file-earmark-excel"></i> Choose Excel File
      </label>
      <span class="import-selected-filename" id="importFileNameDisplay">No file chosen</span>
    </div>
    <span class="import-file-hint"><i class="bi bi-info-circle"></i> Accepted formats: .xlsx, .xls, .csv</span>
  </div>

  <!-- Preview table -->
  <div class="import-table-scroll-wrapper">
    <table class="import-preview-table">
      <thead>
        <tr>
          <th scope="col">Article ID</th>
          <th scope="col">Depth</th>
          <th scope="col">Inside Width</th>
          <th scope="col">Outside Width</th>
          <th scope="col">Product Name</th>
          <th scope="col">Profile Type</th>
          <th scope="col">Country</th>
          <th scope="col">Application</th>
          <th scope="col">Inner Radius</th>
          <th scope="col">Outer Radius</th>
          <th scope="col">Thickness</th>
          <th scope="col">Engineering Code</th>
          <th scope="col">Material</th>
          <th scope="col">Excel File</th>
        </tr>
      </thead>

      <tbody *ngIf="!!articlesFromExcel; else emptyState">
        <tr *ngFor="let article of articlesFromExcel; index as i">
          <td>{{ article.articleId }}</td>
          <td>{{ article.depth }}</td>
          <td>{{ article.insideWidth }}</td>
          <td>{{ article.outsideWidth }}</td>
          <td>{{ article.productName }}</td>
          <td>{{ article.profileType }}</td>
          <td>{{ article.country }}</td>
          <td>{{ article.application }}</td>
          <td>{{ article.innerRadius }}</td>
          <td>{{ article.outerRadius }}</td>
          <td>{{ article.thickness }}</td>
          <td>{{ article.engineeringCode }}</td>
          <td>{{ article.material }}</td>
          <td>{{ article.fileName }}</td>
        </tr>
      </tbody>

      <ng-template #emptyState>
        <tbody>
          <tr>
            <td colspan="14" class="import-empty-state">
              <i class="bi bi-cloud-upload"></i>
              <span>No file selected — upload an Excel file to preview articles</span>
            </td>
          </tr>
        </tbody>
      </ng-template>
    </table>
  </div>

</div>

<div class="modal-footer import-modal-footer">
  <div class="import-error-message" *ngIf="displayError">
    <i class="bi bi-exclamation-triangle-fill"></i> {{errorMessage}}
  </div>
  <button type="button" class="import-btn-upload" (click)="uploadExcelArticles()">
    <i class="bi bi-cloud-upload"></i> Upload
  </button>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="default" color="#fff" type="square-loader" [fullScreen]="false">
  <p class="spinner-loading-text">Uploading...</p>
</ngx-spinner>